export default __webpack_public_path__ + "static/media/AnimalPage3.51b83781.txt";